import { Customer } from '../../types/user.types'
import AccountIcon from '../../assets/icons/account-icon.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'

export const IndividualBeneficiaryItem = ({ customerData, handleOpenMakeIndividualPayment }: { customerData: Customer; handleOpenMakeIndividualPayment: (customerData: Customer) => void }) => {
  return (
    <div
      onClick={() => handleOpenMakeIndividualPayment(customerData)}
      className="individual-money-transfers-latest-beneficiary-item"
    >
      <div className="individual-money-transfers-data-profile">
        <div className="individual-money-transfers-user-image-profile">
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        </div>
        <div className="individual-money-transfers-user-name-profile">{customerData.registeredFullName?.toUpperCase()}</div>
      </div>
      <div className="individual-money-transfers-data-actions">
        <div className="individual-money-transfers-data-arrow-right">
          <img
            src={ArrowRightIcon}
            alt="arrow-right-icon"
          />
        </div>
      </div>
    </div>
  )
}
